var _g, _ellipse, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 245,
    viewBox: "0 0 324 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdi_183_5742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.343 215.162H79.208V215.148C78.7765 215.157 78.3438 215.162 77.91 215.162C45.6489 215.162 19.4961 189.351 19.4961 157.511C19.4961 135.903 31.5408 117.072 49.3654 107.201C49.3568 106.677 49.3525 106.152 49.3525 105.626C49.3525 52.9134 92.65 10.1816 146.06 10.1816C192.131 10.1816 230.677 41.9763 240.401 84.5457C275.653 86.006 303.779 114.674 303.779 149.825C303.779 184.62 276.22 213.063 241.469 215.051V215.162H237.81C237.732 215.162 237.654 215.162 237.576 215.162C237.499 215.162 237.421 215.162 237.343 215.162Z",
    fill: "url(#paint0_radial_183_5742)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    filter: "url(#filter1_di_183_5742)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.91,
    cy: 157.511,
    rx: 58.4139,
    ry: 57.6508,
    fill: "#848484"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.227 153.566C159.427 162.002 149 167.4 137.309 167.4C116.82 167.4 100.211 150.819 100.211 130.366C100.211 109.913 116.82 93.332 137.309 93.332C148.776 93.332 159.028 98.5257 165.833 106.685C169.971 104.169 174.832 102.72 180.032 102.72C195.129 102.72 207.367 114.937 207.367 130.008C207.367 145.079 195.129 157.296 180.032 157.296C174.996 157.296 170.279 155.937 166.227 153.566Z",
    fill: "#007EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.06 147.898C160.971 149.498 161.239 152.373 159.386 154.039C155.721 157.333 151.334 159.761 146.549 161.11C140.309 162.87 133.683 162.715 127.532 160.665C121.382 158.614 115.992 154.764 112.063 149.614C108.134 144.465 105.848 138.254 105.503 131.79C105.158 125.326 106.769 118.907 110.127 113.37C113.485 107.832 118.435 103.432 124.332 100.74C130.23 98.0488 136.802 97.1912 143.194 98.2789C148.095 99.113 152.717 101.061 156.712 103.948C158.731 105.408 158.77 108.295 157.04 110.088C155.315 111.877 152.484 111.887 150.394 110.54C147.761 108.844 144.798 107.687 141.678 107.156C137.071 106.372 132.334 106.99 128.083 108.93C123.832 110.87 120.264 114.042 117.844 118.033C115.423 122.025 114.262 126.651 114.51 131.31C114.759 135.97 116.407 140.446 119.239 144.158C122.071 147.87 125.956 150.646 130.389 152.123C134.823 153.601 139.599 153.713 144.097 152.444C147.142 151.586 149.964 150.121 152.401 148.155C154.337 146.594 157.153 146.302 159.06 147.898Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.122 115.801L157.527 130.191L169.21 144.509C169.263 144.575 169.313 144.642 169.359 144.709C169.389 144.727 169.418 144.746 169.447 144.766C171.641 146.231 174.194 147.358 176.645 147.76C180.08 148.323 183.605 147.877 186.79 146.474C189.975 145.072 192.682 142.775 194.582 139.863C196.482 136.952 197.492 133.551 197.489 130.076C197.486 126.601 196.47 123.202 194.565 120.294C192.66 117.385 189.949 115.093 186.761 113.696C183.574 112.299 180.048 111.859 176.614 112.428C173.819 112.891 171.645 113.893 169.55 115.517C169.414 115.623 169.271 115.717 169.122 115.801ZM165.826 148.671C165.507 148.505 165.22 148.276 164.984 147.993L152.929 133.521L141.17 147.981C140.657 148.613 139.886 148.979 139.073 148.979C136.782 148.979 135.53 146.308 136.995 144.547L148.943 130.191L136.95 115.598C135.496 113.829 136.754 111.166 139.044 111.166C139.874 111.166 140.659 111.546 141.173 112.198L152.929 127.1L164.981 112.186C165.166 111.957 165.384 111.763 165.625 111.607C165.684 111.559 165.747 111.513 165.813 111.468C168.897 109.392 172.597 107.602 175.725 107.084C180.198 106.342 184.791 106.916 188.943 108.735C193.094 110.554 196.626 113.54 199.107 117.329C201.589 121.117 202.912 125.545 202.916 130.071C202.92 134.598 201.604 139.027 199.13 142.82C196.655 146.613 193.129 149.605 188.98 151.431C184.831 153.258 180.24 153.84 175.766 153.106C172.009 152.49 168.781 150.978 165.863 148.7C165.85 148.69 165.838 148.68 165.826 148.671Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_183_5742",
    x: 0.0603752,
    y: 0.463781,
    width: 323.155,
    height: 243.852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.85893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_183_5742"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.71786
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.71786
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2015 0 0 0 0 0.3875 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_183_5742",
    result: "effect2_dropShadow_183_5742"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_183_5742",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.607366,
    dy: 1.21473
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.25156
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_183_5742"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_183_5742",
    x: 14.6372,
    y: 90.1425,
    width: 135.049,
    height: 132.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.21473,
    dy: -6.07366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8221
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_183_5742"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_183_5742",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13.3621,
    dy: 7.28839
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.68103
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_183_5742"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_183_5742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.663 53.8867) rotate(90.6781) scale(161.203 186.389)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureCloud);
export default __webpack_public_path__ + "static/media/feature-cloud.45c9a0e08f9ad07641ce3e165b1e5154.svg";
export { ForwardRef as ReactComponent };